<template>
  <v-dialog v-model="dialogDelete" max-width="500px">
    <v-card>
      <v-card-title class="text-body-1 primary--text justify-center">
        ¿Estás seguro de que quieres eliminar?
      </v-card-title>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey" text @click="deleteItemConfirm()">Si</v-btn>
        <v-btn color="blue" text @click="closeDelete()">NO</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { $EventBus } from "@/main";
export default {
  name: "DeleteApplicationDialog",
  props: {
    application: Object,
  },
  data: () => ({
    dialogDelete: false,
  }),
  watch: {
    application(val) {
      if (val && val.id) {
        this.dialogDelete = true;
      }
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
  methods: {
    async deleteItemConfirm() {
      try {
        await this.$store.dispatch(
          "applications/deleteApplication",
          this.application.id
        );
        this.showSnack("green", "Aplicación eliminada");
      } catch (error) {
        this.showSnack("red", error);
      }
      this.closeDelete();
    },

    showSnack(color = "", text = "") {
      $EventBus.$emit("showSnack", { color, text });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {});
    },
  },
};
</script>
